import React from 'react'
import FileCard from './FileCard'
import FileContainerHeader from './FileContainerHeader'

const FilesContainer = ({ fileDownloadUrls, isGridView, setIsGridView, downloadFileName, handleDelete }) => {
    return (
        <div>
            <FileContainerHeader isGridView={isGridView} setIsGridView={setIsGridView} />
            {
                fileDownloadUrls.length === 0 ? (
                    <div>
                        <h1>No Content Present</h1>
                    </div>
                ) : (
                    <div className={`grid ${isGridView ? 'grid-cols-1 md:grid-cols-3' : 'grid-cols-1'} gap-2`}>
                        {
                            fileDownloadUrls.map((fileURL, index) => <FileCard
                                key={index}
                                fileURL={fileURL}
                                downloadFileName={downloadFileName}
                                handleDelete={handleDelete}
                                isGridView={isGridView}
                                index={index}
                            />)
                        }
                    </div>
                )
            }
        </div>
    )
}

export default FilesContainer